import React from "react";
import { Label } from "@api/graphql/generated/generated-types";
import { Badge, FlowbiteColors } from "flowbite-react";

interface LabelItemProps {
  label: Label;
  isChecked: boolean;
  onToggle: (labelId: string) => void;
  disabled?: boolean;
}

export function LabelItem({
  label,
  isChecked,
  onToggle,
  disabled,
}: LabelItemProps) {
  return (
    <label className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 px-1 py-1 rounded transition-colors duration-150">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => onToggle(label.id)}
        disabled={disabled}
        className="h-4 w-4 text-blue-600 dark:text-blue-400 focus:ring-blue-500 dark:focus:ring-blue-400 border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700"
      />
      <Badge color={label.color as keyof FlowbiteColors}>{label.name}</Badge>
    </label>
  );
}
